import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FieldCombo from '../combos/FieldCombo';
import SchoolClassCombo from '../combos/SchoolClassCombo';
import { Checkbox } from 'primereact/checkbox';
import * as XLSX from "xlsx";
import { Col, Form, Row } from 'react-bootstrap';
import fileSaver from 'file-saver'
import ShowVideo from '../shared/ShowVideo';



export default function SetGradeSheetVisibility(props) {
  const [redirectUrl, setRedirectUrl] = useState("");
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editFormVisible, setEditFormVisible] = useState(false);


  const [currentItem, setCurrentItem] = useState(null);
  const [items, setItems] = useState([]);
  const [filterItems, setFilterItems] = useState([]);
  const LoadingRows = Array.from({ length: 5 });

  const [searchText, setSearchText] = useState("");
  const [searchSchoolClass, setSearchSchoolClass] = useState("");

  useEffect(() => {
    searchStudents();
  }, []);
  const searchStudents = function () {
    setLoading(true);
    var sText = "";
    var sSchoolClassId = "";
    if (searchText != null) {
      sText = searchText;
    }
    if (searchSchoolClass != null) {
      if (searchSchoolClass.id != null) {
        sSchoolClassId = searchSchoolClass.id;
      }
    }

    var params = { login: util.getTrustedUser(), lastIndex: 0, pageSize: 0, schoolClassId: sSchoolClassId, searchText: sText };
    var url = config.Server + `/school/setting/grade-sheet/visibility/get`;
    console.log("params is>", params);
    console.log("url is>", url);
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          console.log("response is>", response);

          setItems(response);
          setFilterItems(response);

          setLoading(false);
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setSaving(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setSaving(false);
      });
  }
  const restoreStudents = function () {
    setLoading(true);

    var params = { login: util.getTrustedUser(), monthInd: 0 };
    var url = config.Server + `/school/setting/grade-sheet/visibility/restore`;
    console.log("params is>", params);
    console.log("url is>", url);
    
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          searchStudents();
        }
        else {
          setLoading(false);
          setErrorMessage(response.message);
          setErorVisible(true);
          setSaving(false);
        }
      })
      .catch(error => {
        setLoading(false);
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setSaving(false);
      });
  }
  const setVisibilityState = function (studentId, visible) {
    var sText = "";
    var sSchoolClassId = "";
    if(studentId == ""){
      if (searchText != null) {
        sText = searchText;
      }
      if (searchSchoolClass != null) {
        if (searchSchoolClass.id != null) {
          sSchoolClassId = searchSchoolClass.id;
        }
      }
      setLoading(true);
    }
    else{

    }

    var params = { login: util.getTrustedUser(), schoolClassId: sSchoolClassId, searchText: sText, studentId:studentId, visible:visible, monthInd: 0 };

    var url = config.Server + `/school/setting/grade-sheet/visibility/set`;
    console.log("params is>", params);
    console.log("url is>", url);
    
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          if(studentId == ""){
            searchStudents();
          }
          else{
            var students = [...items];
            for(var i=0;i<students.length;i++){
              if(students[i].student.id == studentId){
                var ii = {...students[i]};
                ii.visible = visible
                students[i] = ii;
                console.log("found ind>", i);
                break;
              }
            }
            console.log(students);
            setItems(students);
            setFilterItems(students);
          }
          
        }
        else {
          setLoading(false);
          setErrorMessage(response.message);
          setErorVisible(true);
          setSaving(false);
        }
      })
      .catch(error => {
        setLoading(false);
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setSaving(false);
      });
  }
  const onInputChange = function (e, name) {
    var val = '';
    val = (e.target && e.target.value) || '';
    if (name === "searchText") setSearchText(val);
  }

  const onComboChange = function (name, value) {
    if (name === "searchSchoolClass") {
      setSearchSchoolClass(value);
    }
    return
  }

  const setRowActions = function (row) {
    return (
      <Row className="justify-content-md-center" style={{}}>
        <Button icon="pi pi-key" rounded severity="primary" style={{ width: "45px", margin: "0px 3px", float: "right" }} onClick={() => setVisibilityState(row.student.id, !row.visible)} title="تغیر وضعیت مشاهده کارنامه" />
      </Row>
    );
  }
    const showVisibleState = function(row){
      if(row.visible){
        return(
          <div style={{width:"20px", height:"20px", backgroundColor:"#44ee44", borderRadius:"50%"}}></div>
        )
      }
      else{
        return(
          <div style={{width:"20px", height:"20px", backgroundColor:"#ee4444", borderRadius:"50%"}}></div>
        )
      }
    }
  return (
    <>
    <ShowVideo videoId="school_save_students" top={65} md={6} /> 
      <div className="page-caption">قابلیت مشاهده کارنامه دانش آموزان</div>
      <div className="" style={{}}>
        <div style={{ backgroundColor: '#e9edffff', padding: '5px', borderRadius: '5px', width: "100%", display: 'flow-root' }}>
          <Row>
            <Col md={3} style={{ height: "75px", paddingTop: "30px" }}>
              <FloatLabel>
                <InputText value={searchText} onChange={(e) => { onInputChange(e, "searchText") }} id="searchText" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center", padding: '10px' }} />
                <label htmlFor="username">جستجو</label>
              </FloatLabel>
            </Col>
            <Col md={3}>
              <SchoolClassCombo returnFullItem={true} value={searchSchoolClass} onChange={(val) => onComboChange('searchSchoolClass', val)} />
            </Col>
            <Col md={3} style={{paddingTop:"20px"}}>
              <div style={{ float: 'right', margin: '10px', display: 'block', direction: "ltr", textAlign: "right" }}>
                <Button label="جستجو" icon="pi pi-search" onClick={() => searchStudents()} severity="primary" iconPos="right" />
              </div>

            </Col>
          </Row>
        </div>
      </div>
      <div className="card" style={{ overflow: "scroll" }}>
        {
          loading ?
            <DataTable value={LoadingRows} className="p-datatable-striped">
              <Column field="id" header="کد" style={{ width: '20%' }} body={<Skeleton />}></Column>
              <Column field="title" header="عنوان" style={{ width: '80%' }} body={<Skeleton />}></Column>
            </DataTable>
            :
            <>
              <div className='col-12' style={{ overflowX: "scroll" }}>
                <Row style={{}}>
                  <Col md={2}>
                    <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign: "right", margin: "10px" }}>
                      <Button label="بازسازی لیست دانش آموزان" icon="pi pi-plus" onClick={() => restoreStudents()} severity="secondary" iconPos="right" />
                    </div>
                  </Col>
                  <Col md={2}>
                    <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign: "right", margin: "10px" }}>
                      <Button label="برای همه قابل مشاهده" icon="pi pi-key" onClick={() => setVisibilityState("", true)} severity="success" iconPos="right" />
                    </div>
                  </Col>
                  <Col md={2}>
                    <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign: "right", margin: "10px" }}>
                      <Button label="برای همه مخفی شود" icon="pi pi-key" onClick={() => setVisibilityState("", false)} severity="danger" iconPos="right" />
                    </div>
                  </Col>
                </Row>
                <DataTable value={filterItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{ minWidth: '50rem' }} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                  currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                  dataKey="id" selection={currentItem} onSelectionChange={(e) => { setCurrentItem(e.value) }}>
                  <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                  <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                  {config.ShowListId ? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column> : <></>}
                  <Column field="student.nationalId" header={"کد ملی"} sortable className="list-cell-text-align"></Column>
                  <Column field="student.firstname" header={"نام"} sortable className="list-cell-text-align"></Column>
                  <Column field="student.lastname" header={"نام خانوادگی"} sortable className="list-cell-text-align"></Column>
                  <Column field="schoolCalss.name" header={"کلاس"} sortable className="list-cell-text-align"></Column>
                  <Column field="visible" body={(row)=>showVisibleState(row)} sortable header={"قابل مشاهده"} style={{ width: '50px' }} className="list-cell-text-align"></Column>
                  <Column body={(row) => setRowActions(row)} exportable={false} style={{ width: '50px' }}></Column>
                </DataTable>
              </div>
            </>
        }
      </div>
      <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />
    </>
  );
}
